// 用户存和快递存，选择箱格
<template>
  <div class="selectCell">
    <!-- 流程 -->
    <userSaveFlow :index="2" v-if="$store.state.type === 'staff'"></userSaveFlow>
    <expressSaveFlow :index="2" v-else></expressSaveFlow>

    <ul class="cell-list">
      <li
        class="list"
        v-for="(item, index) in box_list"
        :key="index"
        @click="goSelectConsignee(item)">
        <p class="size">{{item.box_type}}</p>
        <p class="num">剩余：{{item.box_num}}</p>
      </li>
    </ul>

    <!-- 上一步 -->
    <span class="turnoverCabinet-btn-back" v-show="$store.state.isShowRBot" @click="back">上一步</span>
  </div>
</template>

<script scoped>
import userSaveFlow from '../userSave/userSaveFlow'
import expressSaveFlow from '../expressSave/expressSaveFlow'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, showToast, showWarning, storage } from '../../../../static/turnoverCabinet/js/utility'

export default {
  name: 'selectCell',
  components: {
    userSaveFlow,
    expressSaveFlow
  },
  data () {
    return {
      box_list: []
    }
  },
  created () {
    console.log('type', this.$store.state.type)
    console.log('deliverData', this.$store.state.deliverData)
    this.getBoxNum()
  },
  mounted () {
  },
  methods: {
    // 获取箱格数量
    getBoxNum: async function () {
      let vm = this
      let data = {
        device_no_id: storage.localGetItem('device_no_id')
      }

      showLoading('获取箱格数量中')
      let res = await cabinetApi.getBoxNum(data)
      hideLoading()
      if (res.meta.code === 200) {
        let box_list = res.data.box_list
        for (let i in box_list) {
          let box_size = box_list[i].box_size
          box_list[i].box_type = box_size === 'A' ? '极大' :
                                box_size === 'B' ? '大' :
                                box_size === 'C' ? '中' :
                                box_size === 'D' ? '小' : '极小'
        }
        vm.box_list = box_list
      } else {
        showWarning(res.meta.message)
      }
      // console.log('res', res)
    },
    // 选择箱格完成后，（是员工用户）跳转到选择取件人页面，（是快递员）跳转到输入手机号页面
    goSelectConsignee: function (box) {
      console.log(box)
      // return
      if (box.box_num == 0) {
        showToast('暂无' + box.box_type + '箱格可租用')
        return
      }
      
      this.$store.state.deliverData.box_style = box.box_size
      let path = this.$store.state.type == 'staff' ? '/selectConsignee' : '/importPhone'
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet' + path
      })
    },
    // 返回上一页 （选择登陆方式）
    back () {
      this.$router.push('/turnoverCabinet/saveSelectWay')
    }
  }
}
</script>

<style>
.selectCell{
  width: 100%;
}

.selectCell .cell-list{
  width: 4.56rem;
  margin:  0 auto;
  padding-top: 0.5rem;
}

.selectCell .cell-list .list{
  width: 100%;
  height: 1.52rem;
  line-height: 1.52rem;
  padding: 0 0.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0.1rem;
  box-shadow: #2c4b64 0px 0px 0.2rem;
}

.selectCell .cell-list .list:nth-child(1){
  background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
  background: linear-gradient(to top,#076abf, #4cacff);
}

.selectCell .cell-list .list{
  background: -webkit-linear-gradient(to top ,#0669be, #4cacff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top,#0669be, #4cacff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top,#0669be, #4cacff); /* Firefox 3.6 - 15 */
  background: linear-gradient(to top,#0669be, #4cacff);
}

.selectCell .cell-list .list .size{
  float: left;
  font-size: 0.66rem;
  font-weight: bold;
}
.selectCell .cell-list .list .num{
  float: right;
  font-size: 0.35rem;
}

</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/common/selectCell.vue